/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

/**
 * Checkout APIs
 */

import getOrderDetails from './getOrderDetails';
import getPaymentDetails from './getPaymentDetails';
import removePromotion from './removePromotion';
import placeOrder from './placeOrder';
import applyGiftCard from './applyGiftCard';
import addRecipient from './addRecipient';
import calculateShipping from './calculateShipping';
import updateCart from './updateCart';
import getCartCount from './getCartCount';
import orderPrepare from './orderPrepare';
import updateBillingAddress from './updateBillingAddress';
import processChasePay from './processChasePay';
import processVisaCheckout from './processVisaCheckout';
import validateOrder from './validateOrder';
import getChasePayCheckoutSession from './getChasePayCheckoutSession';
import getQASAddress from './getQASAddress';
import verifyWine, { verifyWineAndAvailability } from './verifyWine';
import getCityStateFromZip from './getCityStateFromZip';
import getPayPalClientToken from './getPayPalClientToken';
import createOptInEntry from './createOptInEntry';
import addAddonItemsToCart from './addAddonItemsToCart';
import addWrapupsToCart from './addWrapupsToCart';
import rewardElegilibity from './rewardElegilibity';
import rewardBalance from './rewardBalance';
import getGreetingAvailability from './getGreetingAvailability';
import {
    processCgcGreetingCard, processCGCGreetingCardAPI, generateCgcCard, fetchCGCCardData,
    generateCgcLabel, fetchCGCLabeldData, fetchCGCCustomCardData, getCgcCustomCard,
} from './fetchCGCData';
import addToCart from './addToCart';
import getGCIKey from './getGCIKey';
import putPersonalizationResponse from './putPersonalizationResponse';
import getPmallShippingMethods from './getPmallShippingMethods';
import updateUserBilling from './updateUserBilling';

import {
    validateMerchantApplePay,
    savePayMethodApplePay,
    saveShipMethodApplePay,
    authorizeApplePay,
    saveRecipientAddressApplePay,
    cancelApplePay,
    placeOrderApplePay,
} from './applePay';

const orderClient = {
    getPmallShippingMethods,
    getOrderDetails,
    getPaymentDetails,
    getCartCount,
    addToCart,
    addRecipient,
    updateCart,
    calculateShipping,
    removePromotion,
    updateBillingAddress,
    applyGiftCard,
    getChasePayCheckoutSession,
    processChasePay,
    processVisaCheckout,
    orderPrepare,
    placeOrder,
    validateOrder,
    verifyWine,
    validateMerchantApplePay,
    savePayMethodApplePay,
    saveShipMethodApplePay,
    authorizeApplePay,
    saveRecipientAddressApplePay,
    cancelApplePay,
    placeOrderApplePay,
    getCityStateFromZip,
    getPayPalClientToken,
    getQASAddress,
    createOptInEntry,
    addAddonItemsToCart,
    addWrapupsToCart,
    rewardElegilibity,
    rewardBalance,
    getGreetingAvailability,
    processCgcGreetingCard,
    processCGCGreetingCardAPI,
    getGCIKey,
    generateCgcCard,
    fetchCGCCardData,
    generateCgcLabel,
    fetchCGCLabeldData,
    fetchCGCCustomCardData,
    getCgcCustomCard,
    putPersonalizationResponse,
    updateUserBilling,
    verifyWineAndAvailability,
};

export default orderClient;
